export interface FeatureFlags {
  enableCompanyPeriodicReview: boolean;
  enable2025Pricing: boolean;
  enable2025PricingOnboardingYearlyStandard: boolean;
  enableCompanyAddressSelfChange: boolean;
  enableEnhancedBirthCityInput: boolean;
  enableESCDA2025Visuals: boolean;
  enableInvoicingTradeNameOption: boolean;
  enableMandateeOnboarding: boolean;
  enableMultipleTransactionDocs: boolean;
  enableNewCardRenewal: boolean;
  enableNewLandbotFlow: boolean;
  enablePaymentCardPinRetrieval: boolean;
  enableReceiptVatParsing: boolean;
  enableRecurringPayments: boolean;
  enableSasuActivities: boolean;
  enableSasuAddress: boolean;
  enableSasuCapitalVariable: boolean;
  enableSiretWall: boolean;
  enableUrssafV2: boolean;
}

export const ALL_FEATURE_FLAGS = {
  // When working on your local machine
  development: {
    enable2025Pricing: true,
    enable2025PricingOnboardingYearlyStandard: true,
    enableCompanyAddressSelfChange: true,
    enableCompanyPeriodicReview: true,
    enableEnhancedBirthCityInput: true,
    enableESCDA2025Visuals: true,
    enableInvoicingTradeNameOption: true,
    enableMandateeOnboarding: true,
    enableMultipleTransactionDocs: false,
    enableNewCardRenewal: false,
    enableNewLandbotFlow: true,
    enablePaymentCardPinRetrieval: true,
    enableReceiptVatParsing: true,
    enableRecurringPayments: false,
    enableSasuActivities: true,
    enableSasuAddress: true,
    enableSasuCapitalVariable: true,
    enableSiretWall: true,
    enableUrssafV2: true,
  } satisfies FeatureFlags,
  // In production
  production: {
    enable2025Pricing: true,
    enable2025PricingOnboardingYearlyStandard: false,
    enableCompanyAddressSelfChange: false,
    enableCompanyPeriodicReview: false,
    enableEnhancedBirthCityInput: true,
    enableESCDA2025Visuals: false,
    enableInvoicingTradeNameOption: true,
    enableMandateeOnboarding: true,
    enableMultipleTransactionDocs: false,
    enableNewCardRenewal: false,
    enableNewLandbotFlow: true,
    enablePaymentCardPinRetrieval: true,
    enableReceiptVatParsing: true,
    enableRecurringPayments: false,
    enableSasuActivities: true,
    enableSasuAddress: true,
    enableSasuCapitalVariable: true,
    enableSiretWall: true,
    enableUrssafV2: true,
  } satisfies FeatureFlags,
  // In staging
  staging: {
    enable2025Pricing: true,
    enable2025PricingOnboardingYearlyStandard: true,
    enableCompanyAddressSelfChange: true,
    enableCompanyPeriodicReview: false,
    enableEnhancedBirthCityInput: true,
    enableESCDA2025Visuals: true,
    enableInvoicingTradeNameOption: true,
    enableMandateeOnboarding: true,
    enableMultipleTransactionDocs: false,
    enableNewCardRenewal: false,
    enableNewLandbotFlow: true,
    enablePaymentCardPinRetrieval: true,
    enableReceiptVatParsing: true,
    enableRecurringPayments: false,
    enableSasuActivities: true,
    enableSasuAddress: true,
    enableSasuCapitalVariable: true,
    enableSiretWall: true,
    enableUrssafV2: true,
  } satisfies FeatureFlags,
  // When running automated tests
  testing: {
    enable2025Pricing: false,
    enable2025PricingOnboardingYearlyStandard: true,
    enableCompanyAddressSelfChange: true,
    enableCompanyPeriodicReview: false,
    enableEnhancedBirthCityInput: true,
    enableESCDA2025Visuals: true,
    enableInvoicingTradeNameOption: true,
    enableMandateeOnboarding: true,
    enableMultipleTransactionDocs: false,
    enableNewCardRenewal: false,
    enableNewLandbotFlow: true,
    enablePaymentCardPinRetrieval: true,
    enableReceiptVatParsing: true,
    enableRecurringPayments: false,
    enableSasuActivities: true,
    enableSasuAddress: false,
    enableSasuCapitalVariable: true,
    enableSiretWall: true,
    enableUrssafV2: true,
  } satisfies FeatureFlags,
};

export type FeatureFlagsEnv = keyof typeof ALL_FEATURE_FLAGS;
export type FeatureFlagsKey = keyof FeatureFlags;

const getFeatureFlags = (): FeatureFlags => {
  switch (import.meta.env.VITE_FEATURES_ENV) {
    case 'production':
      return ALL_FEATURE_FLAGS.production;

    case 'staging':
      return ALL_FEATURE_FLAGS.staging;

    case 'testing':
      return ALL_FEATURE_FLAGS.testing;

    default:
      return ALL_FEATURE_FLAGS.development;
  }
};

const featureFlags = getFeatureFlags();

export default featureFlags;
